import React from "react";
import { withStyles, Typography, FormControl, InputLabel, Input } from "@material-ui/core";
import Clear from "@material-ui/icons/Clear"
import Check from "@material-ui/icons/Check"

import PropTypes from "prop-types";
import cx from "classnames";

import customInputStyle from "../../assets/jss/material-dashboard-react/customInputStyle";

function CustomInput({ ...props }) {
  const {
    value,
    classes,
    formControlProps,
    labelText,
    id,
    labelProps,
    inputProps,
    error,
    success,
    disabled
  } = props;

  const labelClasses = cx({
    [" " + classes.labelRootError]: error,
    [" " + classes.labelRootSuccess]: success && !error
  });
  const underlineClasses = cx({
    [classes.underlineError]: error,
    [classes.underlineSuccess]: success && !error,
    [classes.underline]: true
  });
  const marginTop = cx({
    [classes.marginTop]: labelText === undefined
  });
  
  return (
    <FormControl
      {...formControlProps}
      className={formControlProps.className + " " + classes.formControl}
    >
      {labelText !== undefined ? (
         <InputLabel
          style={{color:" rgba(0, 0, 0, 0.54)",fontSize: 17}}
          className={classes.labelRoot + labelClasses}
          htmlFor={id}
          {...labelProps}
        >
          {labelText}
        </InputLabel>
      ) : null} 
      <Input
      disabled={disabled}
        value={value}
        classes={{
          root: marginTop,
          disabled: classes.disabled,
          underline: underlineClasses,
        }}
        id={id}
        {...inputProps}
      />
      {props.error ? <Typography style={styles.errorColor}>{props.error}</Typography> : null}
      {error ? (
        <Clear className={classes.feedback + " " + classes.labelRootError} />
      ) : success ? (
        <Check className={classes.feedback + " " + classes.labelRootSuccess} />
      ) : null}
    </FormControl>
  );
}

CustomInput.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.string,
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  error: PropTypes.string,
  success: PropTypes.bool
};

const styles = {
  errorColor: {
    marginRight: "auto",
    color:"#f44336",
  },
};

export default withStyles(customInputStyle)(CustomInput);



// WEBPACK FOOTER //
// ./src/components/CustomInput/CustomInput.jsx